import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import { buildEndpoint, buildQueryUrl, useApiWorker } from 'Utilities';
import DownloadIcon from '../../../Assets/Icons/download.svg';

export const DownloadReportButton: React.FC<{
  fileControllerEndpoint: string;
  id: string;
  filename: string;
}> = ({ fileControllerEndpoint, id, filename }) => {
  const API = useApiWorker();
  const [downloading, setDownloading] = React.useState(false);

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (downloading) return;
    setDownloading(true);
    try {
      const endpoint = buildEndpoint(fileControllerEndpoint, 'download');
      const { data, headers } = await API.get(
        buildQueryUrl(endpoint, { id }),
        { responseType: 'blob' },
      );
      const mimeType = headers['content-type'];
      const contentDisposition: string = headers['content-disposition'] ?? '';
      const match = contentDisposition.match(/filename\*?=(?:UTF-8''|"?)([^";]+)"?/i);
      const serverFilename = match ? decodeURIComponent(match[1]) : null;
      const ext = serverFilename?.includes('.') ? serverFilename.split('.').pop() : null;
      const downloadName = filename ? (ext ? `${filename}.${ext}` : filename) : (serverFilename ?? 'report');
      const url = URL.createObjectURL(new Blob([data], { type: mimeType }));
      if (mimeType === 'application/pdf') {
        window.open(url, downloadName);
      } else {
        const a = document.createElement('a');
        a.href = url;
        a.download = downloadName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
      URL.revokeObjectURL(url);
    } catch {
      // silent fail
    } finally {
      setDownloading(false);
    }
  };

  return (
    <IconButton size="small" onClick={handleClick} disabled={downloading} sx={{ padding: '2px' }}>
      {downloading
        ? <CircularProgress size={16} />
        : <img src={DownloadIcon} alt="download" style={{ display: 'block' }} />
      }
    </IconButton>
  );
};
